module.exports = ".text-link {\n  cursor: pointer; }\n\n.auth-fluid .auth-fluid-bg {\n  position: absolute;\n  margin-left: 480px;\n  min-height: 100vh;\n  min-width: 75vw;\n  background-repeat: no-repeat; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/autenticacion/login/login.component.scss
// module id = ./src/app/components/autenticacion/login/login.component.scss
// module chunks = main